












































import { Component, Prop, Vue } from 'vue-property-decorator'
import CountTo from 'vue-count-to'

@Component({
  name: 'CarddMenu',
  components: {
    'count-to': CountTo,
  },
})
export default class extends Vue {
  @Prop({}) public topMenuData
}
